import { useTranslation } from "react-i18next";
import OptionToggler from "../../../parts/OptionToggler";
import { getUserToRequest } from "./manage-coaches/utils/manage-coaches-utils";
import { PushPressCommunityCardActionsComponent } from "./push-preferences/PushPressCommunityCardActionsComponent";

const PressPreferences = ({
  locals,
  isPressCoach,
  manualMembership,
  userToSendInformation,
  onFormChange,
}) => {
  const { t } = useTranslation("dashboard");
  const { activeUser, organizationOwner } = locals;
  const userToRequest = getUserToRequest(activeUser, organizationOwner);
  const { pressCustomBranding = {}, pressAccountInfo = {} } = userToRequest;
  const { communityLink = "" } = pressCustomBranding;
  const manualMembershipOptions = [
    { label: t("pushPressCommunityCardActions.on"), value: true },
    { label: t("pushPressCommunityCardActions.off"), value: false },
  ];
  const schedulingEnabled = pressAccountInfo.schedulingEnabled === true;
  return (
    <>
      {isPressCoach && (
        <form
          id="form-press"
          method="POST"
          data-noreset
          onChange={onFormChange}
        >
          <input
            type="hidden"
            name="userToSendInformation"
            defaultValue={userToSendInformation}
          />
          <div className="row">
            <p className="mobile-hidden">
              {t("pressPreferences.manualMembershipManagement")}
            </p>
            <div className="only-show-mobile">
              <p>{t("pressPreferences.manualMembershipManagement")}</p>
            </div>
            <OptionToggler
              name="manualMembership"
              options={manualMembershipOptions}
              defaultValue={manualMembership}
            />
          </div>
          <div className="push-community">
            <div className="push-community-card">
              <div className="push-community-card-info">
                <span>{t("pressPreferences.inAppCommunity")}</span>
              </div>
              <PushPressCommunityCardActionsComponent
                accountInfo={pressAccountInfo}
                useLink={false}
                option="inAppCommunityEnabled"
                tooltip={t("pressPreferences.inAppCommunityTooltip")}
              />
            </div>
            <div className="push-community-card">
              <div className="push-community-card-info">
                <span>{t("pressPreferences.externalCommunity")}</span>
              </div>
              <PushPressCommunityCardActionsComponent
                accountInfo={pressAccountInfo}
                communityLinkFromDb={communityLink}
                useLink={true}
                option="externalCommunityEnabled"
                tooltip={t("pressPreferences.externalCommunityTooltip")}
              />
            </div>
          </div>
          <h4 style={{ margin: "1.6rem 0 1.2rem" }}>
            {t("pressPreferences.scheduling")}
          </h4>
          <div className="row">
            <p className="mobile-hidden">
              {t("pressPreferences.schedulingEnabled")}
            </p>
            <div className="only-show-mobile">
              <p>{t("pressPreferences.schedulingEnabled")}</p>
            </div>
            <OptionToggler
              name="schedulingEnabled"
              options={manualMembershipOptions}
              defaultValue={schedulingEnabled}
            />
          </div>
        </form>
      )}
    </>
  );
};
export default PressPreferences;
